/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import isISBN from "validator/lib/isISBN";
import { TextInput } from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import IconWithLabel from "../../widgets/IconWithLabel/IconWithLabel";
import {PERMISSIONS} from "../../constants/constants";

export default class BundleInfo extends Component {
    static propTypes = {
        setComponent: PropTypes.func,
        options: PropTypes.shape({
            bundleInfo: PropTypes.shape.isRequired,
            setBundleInfo: PropTypes.func.isRequired
        })
    };

    componentDidMount() {
        if (typeof this.props.setComponent === "function") {
            this.props.setComponent("BundleInfo");
        }
        this.props.guardDirtySetActive(false);

    }

    render() {
        const { bundleInfo, setBundleInfo } = this.props.options;
        return (
            <div className="bundle-info-container">
                <div className='pe-row'>
                    <div className="pe-col-12">
                        <div className='header-margin'>
                            <label className="pe-title--small">Bundle Information</label>
                        </div>
                    </div>
                </div>
                {bundleInfo.map((bundle, index) => (
                    <div key={index} className={`bundle-info ${bundle.isInvalid && "bundle-info-invalid"} pe-row`}>
                        <div className="bundle-name pe-col-3">
                            Bundled Book #{index + 1}
                        </div>
                        <div className="pe-col-4 bundle-isbn">
                            <TextInput
                                id={bundle.id}
                                value={bundle.isbn || ""}
                                changeHandler={e => {
                                    const updatedBundle = {
                                        ...bundle,
                                        isbn: e.target.value,
                                        isInvalid: e.target.value && !isISBN(e.target.value)
                                    };
                                    setBundleInfo(
                                        bundleInfo.map((prevBundle, i) =>
                                            i === index
                                                ? updatedBundle
                                                : prevBundle
                                        )
                                    );
                                }}
                                labelText="ISBN"
                                inputState={this.props.permissions.includes(PERMISSIONS.view_only_bundle_isbn)? 'disabled' : ''}
                            />
                            <span className="validation-message">Invalid ISBN.</span>
                        </div>
                        <div className="pe-col-5">
                            <TextInput
                                value={bundle.notes || ""}
                                changeHandler={e => {
                                    const updatedBundle = {
                                        ...bundle,
                                        notes: e.target.value
                                    };
                                    setBundleInfo(
                                        bundleInfo.map((prevBundle, i) =>
                                            i === index
                                                ? updatedBundle
                                                : prevBundle
                                        )
                                    );
                                }}
                                labelText="Notes"
                                inputState={this.props.permissions.includes(PERMISSIONS.view_only_bundle_notes)? 'disabled' : ''}
                            />
                        </div>
                    </div>
                ))}

                <div className="add-more">
                    {this.props.permissions.includes(PERMISSIONS.view_only_bundle_add)?
                        <IconWithLabel
                            icon="item-add-24"
                            label="Add more"
                        />
                        :
                        <IconWithLabel
                            icon="item-add-24"
                            label="Add more"
                            onClick={() => setBundleInfo([...bundleInfo, {}])}
                        />
                    }

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BundleInfo.js